import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { 
  Package, 
  FileText, 
  DollarSign, 
  Bell, 
  RefreshCw, 
  Search, 
  Users, 
  BarChart3,
  Truck,
  Settings
} from 'lucide-react';

const DashboardCard = ({ icon: Icon, title, description, onClick, bgColor = "bg-blue-50" }) => (
  <Card 
    className="cursor-pointer hover:shadow-lg transition-shadow duration-200"
    onClick={onClick}
  >
    <CardContent className="p-6">
      <div className="flex items-start gap-4">
        <div className={`${bgColor} rounded-full p-4 flex items-center justify-center`}>
          <Icon size={32} className="text-blue-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-lg uppercase mb-2">{title}</h3>
          <p className="text-sm text-gray-600 leading-relaxed">{description}</p>
        </div>
      </div>
    </CardContent>
  </Card>
);

const MasterDashboardHome = ({ onNavigate }) => {
  const dashboardModules = [
    {
      icon: Package,
      title: "PAQUETES",
      description: "GESTIONAR, BUSCAR, CREAR, ASIGNAR TRACKINGS Y REPORTES",
      section: "packages",
      bgColor: "bg-orange-50"
    },
    {
      icon: Package,
      title: "WAREHOUSE",
      description: "GESTIONAR WAREHOUSE RECEIPTS, REEMPACAR Y CONSOLIDAR",
      section: "warehouse",
      bgColor: "bg-yellow-50"
    },
    {
      icon: DollarSign,
      title: "PAGOS",
      description: "VERIFICAR, PROCESAR Y GESTIONAR PAGOS RECIBIDOS",
      section: "payments",
      bgColor: "bg-green-50"
    },
    {
      icon: FileText,
      title: "GUÍAS",
      description: "CREAR, GESTIONAR Y DESCARGAR GUÍAS DE ENVÍO",
      section: "guides",
      bgColor: "bg-red-50"
    },
    {
      icon: FileText,
      title: "FACTURAS",
      description: "LISTAR, CREAR, ADJUNTAR PAGOS Y GENERAR DOCUMENTOS",
      section: "invoices",
      bgColor: "bg-blue-50"
    },
    {
      icon: Package,
      title: "CONSOLIDADOS",
      description: "LISTAR, BUSCAR Y CREAR NUEVOS CONSOLIDADOS",
      section: "consolidated",
      bgColor: "bg-purple-50"
    },
    {
      icon: Bell,
      title: "ALERTAS",
      description: "VISUALIZAR, RECONOCER Y PROCESAR NOTIFICACIONES",
      section: "alerts",
      bgColor: "bg-indigo-50"
    },
    {
      icon: RefreshCw,
      title: "REEMPAQUES",
      description: "SOLICITUDES, APROBAR Y PROCESAR REEMPAQUES",
      section: "repack-requests",
      bgColor: "bg-teal-50"
    },
    {
      icon: Search,
      title: "BÚSQUEDAS",
      description: "BÚSQUEDA RÁPIDA GLOBAL DE TRACKINGS Y CLIENTES",
      section: "search",
      bgColor: "bg-pink-50"
    },
    {
      icon: Users,
      title: "CASILLEROS",
      description: "LISTAR, BUSCAR Y CREAR NUEVOS CASILLEROS",
      section: "lockers",
      bgColor: "bg-cyan-50"
    },
    {
      icon: BarChart3,
      title: "DASHBOARD",
      description: "MÉTRICAS, ESTADÍSTICAS Y REPORTES GENERALES",
      section: "dashboard",
      bgColor: "bg-emerald-50"
    },
    {
      icon: Settings,
      title: "CONFIGURACIÓN",
      description: "TARIFAS DE ENVÍO, USUARIOS Y PARÁMETROS DEL SISTEMA",
      section: "rates",
      bgColor: "bg-gray-50"
    }
  ];

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Panel de Control Master</h1>
        <p className="text-gray-600 mt-2">Gestiona todas las operaciones del sistema</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {dashboardModules.map((module) => (
          <DashboardCard
            key={module.id || module.title}
            icon={module.icon}
            title={module.title}
            description={module.description}
            onClick={() => onNavigate(module.section)}
            bgColor={module.bgColor}
          />
        ))}
      </div>
    </div>
  );
};

export default MasterDashboardHome;
